import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable, from } from "rxjs";
import { ApplicationService } from "../services";

@Injectable({
  providedIn: "root",
})
export class InitMapGuard {
  constructor(private applicationService: ApplicationService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return from(this.waitForGoogleMaps());
  }

  private async waitForGoogleMaps(): Promise<boolean> {
    if (window.google && window.google.maps) {
      this.applicationService.isMapLoading$.next(false);
      return true;
    }

    return new Promise<boolean>((resolve) => {
      const startTime = Date.now();
      const maxWaitTime = 10000; // 10 seconds in milliseconds

      const checkGoogleMaps = () => {
        if (window.google && window.google.maps) {
          this.applicationService.isMapLoading$.next(false);
          resolve(true);
        } else if (Date.now() - startTime >= maxWaitTime) {
          alert("Google Maps API failed to load within 10 seconds");
          this.applicationService.isMapLoading$.next(false);
          resolve(false);
        } else {
          setTimeout(checkGoogleMaps, 100);
        }
      };

      checkGoogleMaps();
    });
  }
}
